export default __webpack_public_path__ + "static/media/brelgak-01.eed78255.png";